<template>
  <section id="contact" class="hw-section">
    <div class="hw-container hw-contact-grid">
      <div>
        <p class="hw-kicker">Contacto</p>
        <h2 class="hw-title">Vamos construir o próximo produto?</h2>
        <p class="hw-lead">
          Estamos disponíveis para responder a perguntas ou discutir como podemos ajudar a vossa empresa
          a alcançar os objetivos digitais. Escrevam-nos, respondemos depressa.
        </p>
        <div class="hw-contact-item">
          <div class="hw-icon">
            <v-icon color="#7ee8c4">mdi-email-outline</v-icon>
          </div>
          <div>
            <small>Email</small>
            <a href="mailto:hello@hardwired.pt">hello@hardwired.pt</a>
          </div>
        </div>
        <div class="hw-contact-item">
          <div class="hw-icon">
            <v-icon color="#7ee8c4">mdi-whatsapp</v-icon>
          </div>
          <div>
            <small>WhatsApp</small>
            <a href="https://wa.me/351924980957" target="_blank" rel="noopener noreferrer">+351 924 980 957</a>
          </div>
        </div>
        <div class="hw-contact-item">
          <div class="hw-icon">
            <v-icon color="#7ee8c4">mdi-map-marker-outline</v-icon>
          </div>
          <div>
            <small>Morada</small>
            <p>Avenida de Tibães nº1199<br />4770-568 Vale de São Cosme</p>
          </div>
        </div>
      </div>

      <form class="hw-form" @submit.prevent="submit">
        <label class="hw-field">
          <span>Nome</span>
          <input v-model="name" type="text" autocomplete="name" />
          <small class="hw-error">{{ nameError }}</small>
        </label>
        <label class="hw-field">
          <span>E-mail</span>
          <input v-model="email" type="email" autocomplete="email" />
          <small class="hw-error">{{ emailError }}</small>
        </label>
        <label class="hw-field">
          <span>Mensagem</span>
          <textarea v-model="textArea" rows="5"></textarea>
          <small class="hw-error">{{ messageError }}</small>
        </label>
        <button class="hw-btn hw-btn-primary" type="submit" :disabled="sending">
          {{ sending ? "A enviar..." : "Enviar mensagem" }}
        </button>
      </form>
    </div>
    <div v-if="snackbar.enabled" class="hw-toast" :class="snackbar.color">
      {{ snackbar.text }}
    </div>
  </section>
</template>

<script>
import brevo from "../services/Brevo";
export default {
  data: () => ({
    name: "",
    email: "",
    textArea: "",
    submitted: false,
    sending: false,
    snackbar: {
      enabled: false,
      text: "",
      color: "",
    },
  }),
  computed: {
    nameError() {
      if (!this.submitted) return "";
      if (!this.name) return "O campo nome é obrigatório";
      if (this.name.trim().length < 2) return "O nome precisa de ter pelo menos 2 caracteres";
      return "";
    },
    emailError() {
      if (!this.submitted) return "";
      if (!this.email) return "O campo email é obrigatório";
      if (!/.+@.+\..+/.test(this.email)) return "O e-mail precisa de ser válido";
      return "";
    },
    messageError() {
      if (!this.submitted) return "";
      if (!this.textArea) return "O campo de texto é obrigatório";
      if (this.textArea.trim().length < 10) return "Mínimo de 10 caracteres";
      return "";
    },
  },
  methods: {
    snackbarShow(color, text) {
      this.snackbar.color = color;
      this.snackbar.text = text;
      this.snackbar.enabled = true;
      window.setTimeout(() => {
        this.snackbar.enabled = false;
      }, 4000);
    },
    submit() {
      this.submitted = true;
      if (this.nameError || this.emailError || this.messageError || this.sending) return;
      this.sending = true;
      const data = {
        name: this.name,
        email: this.email,
        message: this.textArea,
      };
      brevo.sendInfoEmail(data, (success) => {
        this.sending = false;
        if (success) {
          this.name = "";
          this.email = "";
          this.textArea = "";
          this.submitted = false;
          this.snackbarShow("ok", "A sua mensagem foi enviada. Entraremos em contacto em breve.");
        } else {
          this.snackbarShow("err", "Ocorreu um erro ao enviar a mensagem. Tente novamente mais tarde.");
        }
      });
    },
  },
};
</script>
